import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AlreadyGuard } from './already.guard';
import { AuthGuard } from './auth.guard';
import { RbacGuard } from './rbac-guard';
import { LoaderGuard } from './loader.guard';
import { RoleGuard } from './role.guard';
import { TutorRoleGuard } from './tutor-role.guard';
import { DesktopViewGuard } from './desktop-view.guard';
import { MobileNotSupportedPageComponent } from './shared/mobile-not-supported-page/mobile-not-supported-page.component';

const routes: Routes = [
    {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((m) => m.HomePageModule),
    },
    {
        path: 'register',
        loadChildren: () =>
            import('./auth/register/register.module').then((m) => m.RegisterPageModule),
        canActivate: [AuthGuard, RbacGuard],
        data: { casbinArgs: ['AdminPanel', 'view'] },
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        loadChildren: () => import('./auth/login/login.module').then((m) => m.LoginPageModule),
        canActivate: [AlreadyGuard],
    },
    {
        path: 'dashboard',
        loadChildren: () =>
            import('./auth/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'my-projects',
        loadChildren: () =>
            import('./auth/my-projects/my-projects.module').then((m) => m.MyProjectsPageModule),
        canActivate: [AuthGuard, DesktopViewGuard, RbacGuard],
        data: { casbinArgs: ['My-Projects', 'view'] },
    },
    {
        path: 'my-challenges',
        loadChildren: () =>
            import('./auth/Challenges/my-challenges/challenge-page.module').then(
                (m) => m.ChallengePageModule,
            ),
        canActivate: [AuthGuard, DesktopViewGuard, RbacGuard],
        data: { casbinArgs: ['My-Challenges', 'view'] },
        //'My-Challenges'
    },
    {
        path: 'registration-panel',
        loadChildren: () =>
            import('./auth/registration-panel/registration-panel.module').then(
                (m) => m.RegistrationPanelPageModule,
            ),
        canActivate: [AuthGuard, RbacGuard],
        data: {
            casbinArgs: {
                operator: 'or',
                permissions: [
                    ['Users-Admin', 'new'],
                    ['Users-Student', 'new'],
                    ['Users-Tutor', 'new'],
                    ['Users-Project-Admin', 'new'],
                ],
            },
        },
    },
    {
        path: 'edit-user/:id',
        loadChildren: () =>
            import('./auth/registration-panel/registration-panel.module').then(
                (m) => m.RegistrationPanelPageModule,
            ),
        canActivate: [AuthGuard, RbacGuard],
        data: {
            casbinArgs: {
                operator: 'or',
                permissions: [
                    ['Users-Admin', 'edit'],
                    ['Users-Student', 'edit'],
                    ['Users-Tutor', 'edit'],
                    ['Users-Project-Admin', 'edit'],
                ],
            },
        },
    },
    {
        path: 'change-password/:passwordID',
        loadChildren: () =>
            import('./auth/registration-panel/registration-panel.module').then(
                (m) => m.RegistrationPanelPageModule,
            ),
        canActivate: [AuthGuard, RbacGuard],
        data: {
            casbinArgs: {
                operator: 'or',
                permissions: [
                    ['Users-Admin', 'changepassword'],
                    ['Users-Student', 'changepassword'],
                    ['Users-Tutor', 'changepassword'],
                    ['Users-Project-Admin', 'changepassword'],
                ],
            },
        },
    },
    {
        path: 'term-page',
        loadChildren: () =>
            import('./auth/term-page/term-page.module').then((m) => m.TermPagePageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'course-page',
        loadChildren: () =>
            import('./auth/course-page/course-page.module').then((m) => m.CoursePagePageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'student-course-lesson',
        loadChildren: () =>
            import('./auth/student-course-lesson/student-course-lesson.module').then(
                (m) => m.StudentCourseLessonPageModule,
            ),
        canActivate: [AuthGuard, DesktopViewGuard, RbacGuard],
        data: { casbinArgs: ['Student-Course-Lessons', 'view'] },
    },
    {
        path: 'attendance-tutor',
        loadChildren: () =>
            import('./attendance/attendance-tutor/attendance-tutor.module').then(
                (m) => m.AttendanceTutorModule,
            ),
        canActivate: [RbacGuard],
        data: { casbinArgs: ['Attendance-Tutor', 'view'] },
    },
    {
        path: 'mobile-view-not-supported',
        component: MobileNotSupportedPageComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
